import { useTranslation } from 'react-i18next'
import Sheet from './Sheet'
import ActionBar from './ActionBar'
import { Button, Stack } from '@mui/material';

export default function SelectScanMode(props) {
    // Copy is overridable because the reviewer picks a scope to REVIEW, not to count.
    // Defaults are the clerk's wording, so the scan screen passes nothing.
    const {
        chooseMode,
        showChangeMode,
        setShowChangeMode,
        title,
        categoryLabel,
        allLabel,
        // Which of the two the screen is actually steering towards. A count
        // starts from a category; a review starts from the whole store. It
        // decides both which button leads and which one is filled.
        primaryChoice = 'category',
    } = props;
    const { t } = useTranslation();

    // Defaults are evaluated here, after useTranslation - a parameter default would
    // run before the hook and could not call t().
    const titleText = title ?? t('inventoryCheck.scanMode.titleCount');
    const categoryText = categoryLabel ?? t('inventoryCheck.scanMode.category');
    const allText = allLabel ?? t('inventoryCheck.scanMode.all');

    // The primary choice leads, and it is the filled one. Order and emphasis
    // have to agree: on a sheet you answer by tapping, the top button is the
    // one a thumb reaches first, so a filled button underneath an outlined one
    // would point two ways at once.
    const choices = [
        { mode: 'category', label: categoryText },
        { mode: 'all', label: allText },
    ].sort((a, b) => (b.mode === primaryChoice) - (a.mode === primaryChoice));

    return (
        <Sheet
            open={showChangeMode}
            onClose={() => setShowChangeMode(false)}
            title={titleText}
            actions={<ActionBar cancel={{ label: t('common.cancel'), onClick: () => setShowChangeMode(false) }} />}
        >
            {/* These are the choice, not an answer to it, so they are neither
                ActionBar's job nor sized like a confirm button: full width, stacked,
                and reachable without aiming. */}
            <Stack spacing={1.5}>
                {choices.map(({ mode, label }) => (
                    <Button
                        key={mode}
                        fullWidth
                        variant={mode === primaryChoice ? 'contained' : 'outlined'}
                        color={mode === primaryChoice ? 'primary' : 'inherit'}
                        onClick={() => chooseMode(mode)}
                        sx={{ minHeight: 48 }}
                    >
                        {label}
                    </Button>
                ))}
            </Stack>
        </Sheet>
    )
}
